export default __webpack_public_path__ + "static/media/2.f5c8ed64.png";